import styled from 'styled-components'

const InputAlert = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	width: 100%;

	.tooltip-info-icon {
    color: rgb(133, 100, 4);
  }

	a {
    text-decoration: underline;
  }
`

export default InputAlert